<template>
  <edit-modal
    :caption="caption"
    :wide="step > 0"
    :isActive="isActive">

    <template v-if="step === 0">
      <import-from-file
        v-if="source === 'file'"
        @importfromfile:changed="set">
      </import-from-file>

      <import-from-bundle
        v-else
        @importfrombundle:changed="set">
      </import-from-bundle>
    </template>

    <select-datasets
      v-else
      @selectdatasets:changed="set">
    </select-datasets>

    <hr>

    <save-buttons
      @save="submit"
      @cancel="cancel"
      :saveCaption="(step === 1) ? 'Opslaan' : 'Volgende stap'"
      :disabled="!from">
    </save-buttons>
  </edit-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import EditModal from '../modules/EditModal'
import SelectDatasets from './SelectDatasets'
import ImportFromFile from './ImportFromFile'
import SaveButtons from '../modules/SaveButtons'
import ImportFromBundle from './ImportFromBundle'

export default {
  name: 'ImportDatasets',
  props: {
    isActive: {
      type: Boolean,
      required: true
    },
    source: {
      type: String,
      required: true
    }
  },
  components: {
    EditModal,
    SaveButtons,
    SelectDatasets,
    ImportFromFile,
    ImportFromBundle
  },
  data () {
    return {
      from: null,
      step: 0,
      rows: {
        to: null,
        from: 1
      },
      dryRun: true,
      mapping: [],
      withNewValues: false
    }
  },
  computed: {
    ...mapGetters({
      table: 'tables/table',
      bundle: 'bundles/bundle',
      columns: 'columns/columns',
      datasets: 'datasets/importables'
    }),
    caption () {
      return (this.source === 'file') ? 'Datasets importeren uit Excel-bestand' : 'Datasets importeren uit bundel'
    },
    params () {
      return {
        to: this.bundle.id,
        from: this.from,
        rows: this.rows,
        dryRun: this.dryRun,
        mapping: this.mapping.map((column, index) => {
          if (column) {
            return {
              columnIdx: index,
              columnId: column
            }
          }
        }).filter(column => column),
        tableId: this.table.id,
        withNewValues: this.withNewValues
      }
    },
    isFile () {
      return this.from !== null &&
        isNaN(this.from) &&
        this.from.includes('uploads')
    }
  },
  methods: {
    set (payload) {
      this[payload.key] = payload.value
    },
    reset () {
      this.from = null
      this.step = 0
      this.rows = {
        to: null,
        from: 1
      }
      this.dryRun = true
      this.mapping = []
      this.withNewValues = false
    },
    submit () {
      if (this.step === 1) {
        this.dryRun = false
      }

      this.$store.dispatch('datasets/submitImport', this.params)

      if (this.step === 1) {
        this.reset()
        this.$emit('close')
        this.$store.commit('files/UNSET_FILE')
        this.$store.commit('datasets/CLEAR_IMPORT')
      } else {
        this.step++
      }
    },
    cancel () {
      if (this.isFile) {
        this.$store.dispatch('files/destroy', this.from.replace('uploads/', ''))
        this.$store.commit('datasets/CLEAR_IMPORT')
      }

      this.$emit('close')
    }
  }
}
</script>

<style scoped>

</style>
